import React, { Component } from 'react';
import 'react-bootstrap-table/dist/react-bootstrap-table-all.min.css';
import '../styles/CsvTable.css';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import { Glyphicon } from 'react-bootstrap';
import { toast } from 'react-toastify';
import Loader from 'react-loader';
import ConfirmationDialog from './ConfirmationDialog';
import ButtonS3Uploader from './ButtonS3Uploader';
import ButtonS3Downloader from './ButtonS3Downloader';
import Button from './ButtonLoader';
import AuthManager from '../utils/AuthManager';
import moment from 'moment';
//import { queryRecord, appendRecord, updateRecord } from '../services/aws'
//import { accessToken, env } from '../utils/AuthManager';
const filesize = require('filesize')

let timerId

class CsvTable extends Component {
    state = {
        loading: false,
        loaded: false,
        data: []
    }

    handleError(error) {
        console.error(error);
        var msg = error;
        if (error.message) {
            msg = error.message;
        }
        toast.error(msg, { autoClose: 8000 });
    }

    async componentDidMount() {
        this.getFiles();
        timerId = setInterval(() => { this.getFiles() }, 10000);

        // test record resource

        // let response = await queryRecord(accessToken, env, 'Test6.csv', 'ContactID', '4635')
        // console.log('queryRecord.response:', response)

        // let response = await updateRecord(accessToken, env, 'Test6.csv', 'ContactID', '4635', {E3:"will","30":1337})
        // console.log('updateRecord.response:', response)

        // let response = await appendRecord(accessToken, env, 'Test6.csv', {ContactID:"will1337",'5':'test'})
        // console.log('appendRecord.response:', response)
    }

    componentWillUnmount() {
        clearInterval(timerId)
    }

    getFiles = async () => {
        if (!this.state.loaded)
            this.setState({ loading: true })

        try {
            const response = await AuthManager.getFiles()
            console.log('getFiles.response:',response)
            if (response.success) {
                console.log('GetFiles response:', response.data);
                let files = [];
                if (response.data) {
                    for (var i = 0; i < response.data.length; i++) {
                        const file = response.data[i];
                        file.lastModified = moment(file.lastModified);
                        files.push(file)
                    }
                }
                this.setState({ data: files })
                if (files.some(x => x.disabled === true && !x.metadata.error)) {
                    this.handleError('Some file(s) are yet to be imported.You cannot download or delete them')
                }
                for (let index = 0; index < files.length; index++) {
                    const file = files[index];
                    if (file.metadata.error)
                        this.handleError(`File ${file.fileName} failed to upload:${file.metadata.error}. Please click the delete button to delete the file.`)
                }
            }
            else {
                this.handleError(response.message);
            }
        } catch (error) {
            this.handleError(error);
        }
        finally {
            this.setState({ loading: false, loaded: true })
        }
    }

    createCustomInsertButton = () => (
        <ButtonS3Uploader
            bsStyle="info"
            title="Upload"
            processName="upload"
            icon={<Glyphicon className="CsvTable-actionButton-icon" glyph="upload" />}
            accept=".csv"
            validateExtension=".csv"
            onError={this.handleError}
            onFinish={this.onUploadFinish}
            uploadRequestHeaders={{}}
            onClick={() => { return false; }}
            csvdata={this.state.data}>
            Upload
            </ButtonS3Uploader>
    )


    onUploadFinish = async (signResult) => {
        const url = new URL(signResult.signedUrl)
        console.log('Url:', url)
        let fileName = url.pathname.substring(url.pathname.lastIndexOf('/'), url.pathname.length)
        if (fileName.startsWith('/'))
            fileName = fileName.substr(1)

        toast.info(`${fileName} is being processed`, {autoClose:8000})
    }

    onClickDelete = (cell, row, rowIndex) => {
        this.confirmationDialog.showDialog('Are you sure to delete \'' + row.fileName + '\'?', async () => {
            console.log(`Delete CSV #${rowIndex}, filename:${JSON.stringify(row)}`)
            this.setState((prevState) => {
                const newData = prevState.data.slice()
                newData[rowIndex].deleting = true
                return { data: newData }
            })
            try {
                const response = await AuthManager.deleteFile(row.fileName)
                if (response.success) {
                    this.setState((prevState) => {
                        let newData = prevState.data.slice();
                        newData.splice(rowIndex, 1);// remove data
                        return { data: newData };
                    });
                } else throw response.message
            } catch (error) {
                this.setState((prevState) => {
                    const newData = prevState.data.slice();
                    newData[rowIndex].deleting = false;
                    return { data: newData };
                });
                this.handleError(error);
            }
        })
    }

    onGetDownloadUrl = async (cell, row, rowIndex, callback) => {
        console.log('Download CSV #', rowIndex, ', fileName: ', row);
        try {
            const response = await AuthManager.downloadFile(row.fileName)
            if (response.success) callback({ signedUrl: response.preSignedUrl })
            else {
                callback();
                this.handleError(response.message);
            }
        } catch (error) {
            callback();
            this.handleError(error);
        }
    }

    sizeFormatter = (cell) => filesize(cell, {round:0})

    buttonFormatter = (cell, row, enumObject, rowIndex) => {
        return (
            <div>
                <Button bsStyle="danger" title="Delete" bsSize="xs" className="CsvTable-actionButton" loading={this.state.data[rowIndex].deleting}
                    disabled={this.state.data[rowIndex].disabled && !this.state.data[rowIndex].metadata.error} icon={<Glyphicon glyph="trash" />} onClick={() => this.onClickDelete(cell, row, rowIndex)} />

                <ButtonS3Downloader bsStyle="success" title="Download" bsSize="xs" className="CsvTable-actionButton"
                    icon={<Glyphicon glyph="download" />} getSignedUrl={(calback) => this.onGetDownloadUrl(cell, row, rowIndex, calback)} disabled={this.state.data[rowIndex].disabled} file={row.fileName} />

                <ButtonS3Uploader bsStyle="info" title="Update" bsSize="xs" icon={<Glyphicon className="CsvTable-actionButton-icon" glyph="upload" />}
                    accept=".csv" validateExtension=".csv"
                    onError={this.handleError} onFinish={this.onUploadFinish} uploadRequestHeaders={{}}
                    fileName={row.fileName}
                    processName="update"
                    disabled={this.state.data[rowIndex].disabled}
                    csvdata={this.state.data}>Update
                </ButtonS3Uploader>
            </div>
        );
    }

    render() {
        const options = {
            insertBtn: this.createCustomInsertButton
        };

        return (
            <div className="CsvTable">
                <ConfirmationDialog ref={(dialog) => { this.confirmationDialog = dialog; }} />
                <Loader loaded={!this.state.loading}>
                    <BootstrapTable data={this.state.data} options={options} striped={true} hover={true} bordered={false} insertRow >
                        <TableHeaderColumn isKey dataField='fileName' dataSort={true}>Name</TableHeaderColumn>
                        <TableHeaderColumn dataField='lastModified' dataSort={true} width='300'>Last modified</TableHeaderColumn>
                        <TableHeaderColumn dataField='size' dataSort={true} width='90' dataAlign='right' dataFormat={this.sizeFormatter}>Size</TableHeaderColumn>
                        <TableHeaderColumn dataField="button" width='160' dataFormat={this.buttonFormatter}></TableHeaderColumn>
                    </BootstrapTable>
                </Loader>
            </div>
        );
    }
}

export default CsvTable;